export default "__VITE_ASSET__CoxY_V3n__"